
class SocketClient {
  static presentationId  = "check";
  static socket = new WebSocket(`wss://nyguv9zs74.execute-api.eu-west-1.amazonaws.com`);


   static  initSocket(id) {
    this.presentationId = id
   // this.socket =  new WebSocket(`wss://nyguv9zs74.execute-api.eu-west-1.amazonaws.com/production?id=${id}`);
     console.log("socket connect >>", this.socket);
  }

  static getSocket() {
    const  id = this.presentationId;
    this.socket.onclose = function(e) {
       console.log("socket Closed >>", this.socket);
        setTimeout(function () {
           // this.socket =  new WebSocket(`wss://nyguv9zs74.execute-api.eu-west-1.amazonaws.com/production?id=${id}`);
        }, 5000);

    }
    this.socket.onerror = function (err) {
       console.log("socket Error >>", err);
        setTimeout(function () {
           // this.socket =  new WebSocket(`wss://nyguv9zs74.execute-api.eu-west-1.amazonaws.com/production?id=${id}`);
        }, 5000);
  };

    return SocketClient.socket;
  }

  static sendMessage(message){
    try{
      this.socket.send(message);
        console.log("options 1 sendMessage", message);
    }catch (e){
        console.log("options 1 sendMessage ERROR", e);
       console.log("SOCKET SENT MESSAGE ERROR ",e)
    }
   }
}

export default SocketClient;
